import React from "react";
import { Navigate } from "react-router-dom";
import { usePersistData } from "../store";

const ProtectedRoute = ({ component: Component }) => {
  const { user } = usePersistData();

  return user ? <Component /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
